import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  performanceFrontlineReactivatedClientsCountById,
  performanceGen0ReactivatedClientsCountById,
  performanceNewFrontlineClientsCountById,
  performanceNewFrontlineCoachesCountById,
  performanceNewGen0ClientsCountById,
  performanceNewGen0CoachesCountById,
  performanceNewOrgClientsCountById,
  performanceNewOrgCoachesCountById,
  performanceOrderingEntitiesCountById,
  performanceQualifyingPointsById,
} from '/redux/selector/coach.selector';

import MiscMetrics from './MiscMetrics';

export default connect(
  createStructuredSelector({
    newFrontlineClientsCount: performanceNewFrontlineClientsCountById,
    newGen0ClientsCount: performanceNewGen0ClientsCountById,
    newOrgClientsCount: performanceNewOrgClientsCountById,
    newFrontlineCoachesCount: performanceNewFrontlineCoachesCountById,
    newGen0CoachesCount: performanceNewGen0CoachesCountById,
    newOrgCoachesCount: performanceNewOrgCoachesCountById,
    orderingEntitiesCount: performanceOrderingEntitiesCountById,
    qualifyingPoints: performanceQualifyingPointsById,
    frontlineReactivatedClientsCount:
      performanceFrontlineReactivatedClientsCountById,
    gen0ReactivatedClientsCount: performanceGen0ReactivatedClientsCountById,
  }),
)(MiscMetrics);
